exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".k-pagination-footer{background:#e4eaf0;padding:2px 6px}.k-page-nav-ctrls{text-align:center}.k-page-nav-ctrls button{margin:0;width:28px}\n", ""]);

// exports
